<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <div
      class="d-flex pa-2 flex-row flex-wrap"
      :style="{ height: 'fit-content' }"
    >
      <card-row
        :title="'Search'"
        :textColor="'black'"
        :cardColor="'white'"
        :displayed="true"
      >
        <div style="width: 100%">
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                id="mid_bank"
                v-model="search.mid_bank"
                label="MID"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                id="billNumber"
                v-model="search.bill_num"
                label="Bill Number"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field id="reffID" v-model="search.rrn" label="Reff ID" />
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                :items="settlementTypeItems"
                v-model="search.settlement_type"
                label="Settlement Type"
              />
            </v-col>
            <v-col cols="12" sm="12" md="9">
              <v-dialog
                ref="rangeDateDialog"
                v-model="rangeDateDialog"
                :return-value.sync="search.trx_datetime"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    id="rangeDate"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    v-model="dateRangeText"
                    label="Transaction Date"
                  />
                </template>
                <v-date-picker
                  v-model="search.trx_datetime"
                  scrollable
                  range
                  :max="getTommorowDate(-1)"
                >
                  <v-spacer />
                  <v-btn text color="primary" @click="rangeDateDialog = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="
                      () => {
                        checkRangeDate();
                        $refs.rangeDateDialog.save(search.trx_datetime);
                      }
                    "
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row class="d-flex align-center justify-left ma-1">
            <v-btn color="primary" @click.stop="getData">show</v-btn>
          </v-row>
        </div>
      </card-row>
    </div>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
      class="ma-2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="dataSettlement"
      :options.sync="options"
      :server-items-length="totalDataSettlement"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      sort-by="id"
      :style="{ padding: '10px', height: '70vh' }"
      fixed-header
    >
      <template v-slot:top>
        <v-toolbar flat style="overflow-x: scroll; overflow-y: hidden">
          <v-chip
            style="min-width: 160px"
            class="mr-2"
            v-if="selectedData.length > 0"
            close
            @click:close="clearSelected"
          >
            {{ `${selectedData.length} data(s) selected` }}
          </v-chip>
          <v-spacer />
          <template>
            <v-btn
              color="primary"
              class="mb-2"
              @click="openRegenerateModal"
              :style="{ 'margin-right': '10px' }"
              :disabled="loading"
              >Regenerate
            </v-btn>
            <!-- <v-btn
              color="red"
              dark
              class="mb-2"
              @click="() => (dialogRegenerateAll = true)"
              :style="{ 'margin-right': '10px' }"
              :disabled="loading"
              >Regenerate All
            </v-btn> -->
            <v-btn
              color="warning"
              class="mb-2"
              @click="getData"
              :style="{ 'margin-right': '10px' }"
              :loading="loading"
              :disabled="loading"
              ><v-icon>mdi-restart</v-icon
              ><template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link @click="exportItem(false)">
                  <v-list-item-icon>
                    <v-icon>mdi-file-excel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Export to excel</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="exportItem(true)">
                  <v-list-item-icon>
                    <v-icon>mdi-file-excel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title
                    >Export selected to excel</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:[`header.selectAll`]="{ header }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-checkbox
                class="ma-0"
                dense
                hide-details="true"
                v-model="selectAllData"
                @click="selectAll(selectAllData)"
              />
            </div>
          </template>
          <span>{{ header.text }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="viewItem(item)"> mdi-eye </v-icon>
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer' }"
          :class="selectedRow == index ? 'indigo lighten-5' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-checkbox
              class="ma-0"
              dense
              hide-details="true"
              v-model="selectedData"
              :value="item.id"
              :disabled="item.disable_status == 1 ? true : false"
            />
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.bill_num }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mid_bank }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mpan }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.rrn }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.qr_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.trx_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.settlement_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.issuer_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.customer_pan }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.customer_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.payment_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.payment_channel }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.amount }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.trx_datetime }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.settlement_status }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.resettlement_status }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.resettlement_count }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.resettlement_date }}
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="clearSearch"
          :disabled="loading"
          :loading="loading"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogRegenerate" width="500">
      <v-card>
        <v-card-title>
          Are you sure want to regenerate settlement ?
        </v-card-title>
        <v-card-text> Caution: this action cannot be undone ! </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="regenerate"
            :disabled="loading"
            :loading="loading"
          >
            Regenerate
          </v-btn>
          <v-btn dark color="red" @click="() => (dialogRegenerate = false)">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRegenerateAll" width="500">
      <v-card>
        <v-card-title>
          Are you sure want to regenerate all settlement ?
        </v-card-title>
        <v-card-text> Caution: this action cannot be undone ! </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="regenerateAll"
            :disabled="loading"
            :loading="loading"
          >
            Regenerate
          </v-btn>
          <v-btn dark color="red" @click="() => (dialogRegenerateAll = false)">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import {
  dataMaxSelectedGenerateSettlement,
  dataSettlementTypeItems,
} from '../../store/params';
import { isEmpty, date, showAlert, getTommorowDate } from '../../lib/helpers';

export default {
  components: {
    CardRow: () => import('../../components/CardRow.vue'),
  },
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    dialogRegenerate: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'trx_id',
        sortable: false,
        width: '10',
      },
      {
        text: 'Select All',
        align: 'start',
        value: 'selectAll',
        sortable: false,
      },

      {
        text: 'Bill Number',
        value: 'bill_num',
        width: '150',
        align: 'center',
      },
      {
        text: 'Merchant Name',
        value: 'merchant_name',
        width: '150',
        align: 'center',
      },
      {
        text: 'MID',
        value: 'mid_bank',
        width: '150',
        align: 'center',
      },
      {
        text: 'Merchant PAN',
        value: 'mpan',
        width: '150',
        align: 'center',
      },
      {
        text: 'Reff ID',
        value: 'rrn',
        width: '150',
        align: 'center',
      },
      {
        text: 'QR Type',
        value: 'qr_type',
        width: '100',
        align: 'center',
      },
      {
        text: 'Transaction Type',
        value: 'trx_type',
        width: '100',
        align: 'center',
      },
      {
        text: 'Settlement Type',
        value: 'settlement_type',
        width: '100',
        align: 'center',
      },
      {
        text: 'Issuer Name',
        value: 'issuer_name',
        width: '100',
        align: 'center',
      },
      {
        text: 'Customer PAN',
        value: 'customer_pan',
        width: '150',
        align: 'center',
      },
      {
        text: 'Customer Name',
        value: 'customer_name',
        width: '150',
        align: 'center',
      },
      {
        text: 'Payment Type',
        value: 'payment_type',
        width: '100',
        align: 'center',
      },
      {
        text: 'Acquirer Name',
        value: 'payment_channel',
        width: '150',
        align: 'center',
      },
      {
        text: 'Total Amount',
        value: 'amount',
        width: '150',
        align: 'center',
      },
      {
        text: 'Transaction Date',
        value: 'trx_datetime',
        width: '150',
        align: 'center',
      },
      {
        text: 'Settlement Status',
        value: 'settlement_status',
        width: '100',
        align: 'center',
      },
      {
        text: 'Resettlement Status',
        value: 'resettlement_status',
        width: '100',
        align: 'center',
      },
      {
        text: 'Resettlement Calculation',
        value: 'resettlement_count',
        width: '100',
        align: 'center',
      },
      {
        text: 'Resettlement Date',
        value: 'resettlement_date',
        width: '150',
        align: 'center',
      },
      // { text: "Action", value: "actions" },
    ],
    editedIndex: -1,
    search: {
      mid_bank: '',
      bill_num: '',
      rrn: '',
      settlement_type: '',
      trx_datetime: [],
    },
    todayDate: date,
    selectedRow: '',
    selectedData: [],
    selectAllData: false,
    maxSelected: dataMaxSelectedGenerateSettlement,
    settlementTypeItems: dataSettlementTypeItems,
    rangeDateDialog: false,
    isFirstLoad: true,
    dialogRegenerateAll: false,
  }),

  computed: {
    flashError: {
      get() {
        return this.$store.state.reconciliation.regenerateSettlement.flashError;
      },
      set() {
        this.$store.commit('reconciliation/regenerateSettlement', '');
      },
    },

    dateRangeText() {
      return this.search.trx_datetime.join(' ~ ');
    },

    ...mapState('reconciliation/regenerateSettlement', {
      loading: (state) => state.isLoading,
      flashErrorMessage: 'flashErrorMessage',
      dataSettlement: 'allSettlement',
      totalDataSettlement: 'totalSettlement',
    }),
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit(
            'reconciliation/regenerateSettlement/clearSettlement'
          );
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
    selectedData: {
      handler() {
        if (this.selectedData.length > this.maxSelected) {
          this.$vuetify.goTo(0);
          showAlert(
            this.$store,
            `Limit selected data is ${this.maxSelected} !`,
            'mdi-alert',
            'red'
          );
          this.selectedData.splice(
            this.maxSelected,
            this.selectedData.length - 1
          );
        }
        this.checkAllSelected();
      },
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.mid_bank = '';
      this.search.bill_num = '';
      this.search.rrn = '';
      this.search.settlement_type = '';
      this.search.trx_datetime = [];
      this.$nextTick(() => {
        this.getData();
      });
    },

    openRegenerateModal() {
      if (this.selectedData.length < 1) {
        this.dialogRegenerate = false;
        showAlert(this.$store, 'Data must be selected!', 'mdi-alert', 'red');
      } else {
        this.dialogRegenerate = true;
      }
    },

    selectAll(status) {
      this.$nextTick(() => {
        const allIds = this.dataSettlement.map((val) => ({
          id: val.id,
          disable: val.disable_status,
        }));
        const filtered = allIds
          .filter(
            (val) => !this.selectedData.includes(val.id) && val.disable == 0
          )
          .map((v) => v.id);
        if (status) {
          this.selectedData = this.selectedData.concat(filtered);
        } else {
          this.selectedData = this.selectedData.filter(
            (val) => !allIds.map((v) => v.id).includes(val)
          );
        }
      });
    },

    clearSelected() {
      this.selectedData = [];
      this.selectAllData = false;
    },

    checkRangeDate() {
      if (this.search.trx_datetime.length == 1) {
        this.search.trx_datetime.push(this.search.trx_datetime[0]);
      }
    },

    regenerate() {
      this.$store
        .dispatch('reconciliation/regenerateSettlement/regenerate', {
          date,
          id: this.selectedData,
        })
        .then((res) => {
          if (res) {
            this.clearSelected();
            this.getData();
          }
        })
        .finally(() => {
          this.dialogRegenerate = false;
        });
    },

    regenerateAll() {
      if (this.dataSettlement.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data not found !', 'mdi-alert', 'red');
        this.$store.commit(
          'reconciliation/regenerateSettlement/clearSettlement'
        );
        this.dialogRegenerateAll = false;
      } else {
        this.$store
          .dispatch('reconciliation/regenerateSettlement/regenerate', {
            date,
            id: null,
            search: this.search,
          })
          .then((res) => {
            if (res) {
              this.clearSelected();
              this.getData();
            }
          })
          .finally(() => {
            this.dialogRegenerateAll = false;
          });
      }
    },

    getData() {
      if (
        isEmpty(this.search.mid_bank) ||
        this.search.trx_datetime.length < 1
      ) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'MID & Trx Date required !', 'mdi-alert', 'red');
        this.$store.commit(
          'reconciliation/regenerateSettlement/clearSettlement'
        );
      } else {
        const [date1, date2] = this.search.trx_datetime;
        const d1 = Date.parse(date1);
        const d2 = Date.parse(date2);

        if (d1 > d2) {
          const temp = date2;
          this.search.trx_datetime[1] = date1;
          this.search.trx_datetime[0] = temp;
        }

        this.$store.commit(
          'reconciliation/regenerateSettlement/setFlashErrorMessage',
          ''
        );
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('reconciliation/regenerateSettlement/getData', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          })
          .finally(() => {
            this.checkAllSelected();
          });
      }
    },

    checkAllSelected() {
      const allIds = this.dataSettlement.map((val) => ({
        id: val.id,
        disable: val.disable_status,
      }));
      const allSelected = allIds
        .filter(
          (val) => !this.selectedData.includes(val.id) && val.disable == 0
        )
        .map((v) => v.id);
      const allDisabled = allIds
        .filter((val) => val.disable == 1)
        .map((v) => v.id);
      if (
        allSelected.length == 0 &&
        this.dataSettlement.length != 0 &&
        allDisabled.length != allIds.length
      ) {
        this.selectAllData = true;
      } else {
        this.selectAllData = false;
      }
    },

    viewItem(item) {
      this.$router.push(`/reconciliation/regenerateSettlement/view/${item.id}`);
    },

    closeFlash() {
      this.$store.commit(
        'reconciliation/regenerateSettlement/setFlashErrorMessage',
        ''
      );
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    exportItem(selected) {
      if (selected) {
        if (this.selectedData.length < 1) {
          showAlert(this.$store, 'Data must be selected!', 'mdi-alert', 'red');
          this.$vuetify.goTo(0);
          return;
        }
      } else if (this.totalDataSettlement <= 0) {
        showAlert(this.$store, 'No data exported !', 'mdi-alert', 'red');
        this.$vuetify.goTo(0);
        return;
      }

      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store.dispatch('reconciliation/regenerateSettlement/exportList', {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search: this.search,
        view: 'regenerate-settlement',
        id: selected ? this.selectedData : null,
      });
    },

    isEmpty,
    getTommorowDate,
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
